var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGallery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M240 30c11.046 0 20 8.954 20 20v180c0 11.046-8.954 20-20 20H40c-11.046 0-20-8.954-20-20V50c0-11.046 8.954-20 20-20zm-74.343 115.657a8 8 0 0 0-11.314 0l-28.686 28.686a8 8 0 0 1-11.314 0l-8.686-8.686a8 8 0 0 0-11.314 0l-30.686 30.686c-5.04 5.04-1.47 13.657 5.657 13.657h141.372c7.128 0 10.697-8.617 5.657-13.657zM95 90c-13.807 0-25 11.193-25 25s11.193 25 25 25 25-11.193 25-25-11.193-25-25-25"
})));
export default SvgGallery;